export default __webpack_public_path__ + "static/media/image-ph-health-alarm-m.e11a7763.png";